import { render, staticRenderFns } from "./FontFormatButton.vue?vue&type=template&id=78e02bc6"
import script from "./FontFormatButton.vue?vue&type=script&lang=js"
export * from "./FontFormatButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports